export default "__VITE_ASSET__7d9136cd__"